var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spnod-admin__form--container container mx-0 w-100",
    class: _vm.isMobile ? 'px-0' : 'px-3'
  }, [(_vm.getMyInfo._id) ? _c('b-form', {
    attrs: {
      "id": "form"
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_c('b-form-row', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-checkbox', {
    staticClass: "checkbox d-flex align-items-center pr-1 py-0",
    attrs: {
      "id": "client"
    },
    model: {
      value: (_vm.form.isClient),
      callback: function($$v) {
        _vm.$set(_vm.form, "isClient", $$v)
      },
      expression: "form.isClient"
    }
  }, [_vm._v("\n        Member\n      ")]), _vm._v(" "), _c('div', [(!_vm.isTablet) ? _c('b-icon-question-circle-fill', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right.v-secondary",
      value: (_vm.copy.athlete),
      expression: "copy.athlete",
      modifiers: {
        "hover": true,
        "right": true,
        "v-secondary": true
      }
    }],
    staticClass: "icon",
    attrs: {
      "variant": "secondary"
    }
  }) : _c('b-icon-question-circle-fill', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.click.right.v-secondary",
      value: (_vm.copy.athlete),
      expression: "copy.athlete",
      modifiers: {
        "click": true,
        "right": true,
        "v-secondary": true
      }
    }],
    staticClass: "icon",
    attrs: {
      "variant": "secondary"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-row', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-checkbox', {
    staticClass: "checkbox d-flex align-items-center pr-1 py-0",
    attrs: {
      "id": "parentGuardian"
    },
    model: {
      value: (_vm.form.parentGuardian),
      callback: function($$v) {
        _vm.$set(_vm.form, "parentGuardian", $$v)
      },
      expression: "form.parentGuardian"
    }
  }, [_vm._v("\n        Parent / Guardian\n      ")]), _vm._v(" "), _c('div', [(!_vm.isTablet) ? _c('b-icon-question-circle-fill', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right.v-secondary",
      value: (_vm.copy.parentGuardian),
      expression: "copy.parentGuardian",
      modifiers: {
        "hover": true,
        "right": true,
        "v-secondary": true
      }
    }],
    staticClass: "icon",
    attrs: {
      "variant": "secondary"
    }
  }) : _c('b-icon-question-circle-fill', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.click.right.v-secondary",
      value: (_vm.copy.parentGuardian),
      expression: "copy.parentGuardian",
      modifiers: {
        "click": true,
        "right": true,
        "v-secondary": true
      }
    }],
    staticClass: "icon",
    attrs: {
      "variant": "secondary"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-row', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-checkbox', {
    staticClass: "checkbox d-flex align-items-center pr-1 py-0",
    attrs: {
      "id": "coach"
    },
    model: {
      value: (_vm.form.isCoach),
      callback: function($$v) {
        _vm.$set(_vm.form, "isCoach", $$v)
      },
      expression: "form.isCoach"
    }
  }, [_vm._v("\n        Coach\n      ")]), _vm._v(" "), _c('div', [(!_vm.isTablet) ? _c('b-icon-question-circle-fill', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right.v-secondary",
      value: (_vm.copy.coach),
      expression: "copy.coach",
      modifiers: {
        "hover": true,
        "right": true,
        "v-secondary": true
      }
    }],
    staticClass: "icon",
    attrs: {
      "variant": "secondary"
    }
  }) : _c('b-icon-question-circle-fill', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.click.right.v-secondary",
      value: (_vm.copy.coach),
      expression: "copy.coach",
      modifiers: {
        "click": true,
        "right": true,
        "v-secondary": true
      }
    }],
    staticClass: "icon",
    attrs: {
      "variant": "secondary"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-group', {
    staticClass: "d-flex justify-content-end"
  }, [(_vm.form.isClient || _vm.form.parentGuardian || _vm.form.isCoach) ? _c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "type": "submit",
      "size": "sm"
    }
  }, [_vm._v("Send")]) : _vm._e(), _vm._v(" "), (!_vm.form.isClient && !_vm.form.parentGuardian && !_vm.form.isCoach) ? _c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "disabled": "",
      "type": "submit",
      "size": "sm"
    }
  }, [_vm._v("Send")]) : _vm._e()], 1)], 1) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27c0cc66","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Forms/RoleForm.vue
// module id = NgP7
// module chunks = 2